<template>
  <div class="min-h-integrationCard flex flex-col justify-between shadow-appComponent border-signableBrandColours-midGrey border-solid border-1 rounded-xl p-base">
    <div class="integration-overview">
      <VIntegrationStatus
        v-if="integration.instance"
        :integration="integration">
      </VIntegrationStatus>
      <img :src="integrationImage" :alt="$t(`companySettings.integrations.${integration.slug}.name`)">
      <h2>{{ $t(`companySettings.integrations.${integration.slug}.name`) }}</h2>
      <p>{{ $t(`companySettings.integrations.${integration.slug}.headline`) }}</p>
    </div>
    <div>
      <ButtonLink
        :to="integration.cta_link"
        target="_blank"
        class="mt-base"
        :data-ec="`integration_overview_${integration.slug}`"
        data-et="manage_integration_button"
      >
        <span>{{ $t(`companySettings.integrations.${integration.slug}.cta`) }}</span>
      </ButtonLink>
    </div>
  </div>
</template>

<script>
import ButtonLink from '@/components/library/links/ButtonLink.vue';
import VIntegrationStatus from '@/views/components/IntegrationStatus.vue';

export default {
  name: 'VExternalIntegrationOverview',
  props: {
    integration: {
      type: [Object],
      required: true,
    },
  },
  components: {
    VIntegrationStatus,
    ButtonLink,
  },
  computed: {
    integrationImage() {
      return `/img/integrations/${this.integration.slug}.png`;
    },
  },
};

</script>

<style scoped>
.integration-overview {
  display: block;
  position: relative;
  background: #ffffff;
  clear: both;
  overflow: auto;
}
.integration-overview img {
  width: auto;
  height: 50px;
  margin-bottom: var(--spacing-base);
}
</style>
